<template>
  <div style="padding: 10px">
    <reload v-if="reload_hab"></reload>
    <div class="col-md-12">
      <h4>Manifestações</h4>
    </div>
    

    <modal name="manif" :width="1000" :height="350" :adaptive="true" :resizable="true" >
      <div class="col-md-12" v-if="result_detalhes">
        <div class="card" style="margin-top: 20px;border: 1px solid rgb(0 0 0 / 0%);">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                Numero da Manifestação: {{ result_detalhes.numero_manifesto }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                Tipo: {{ result_detalhes.tipo_assunto }}
              </div>
              <div class="col-md-12">
                Unidade Organizacional: {{ result_detalhes.secretaria }}
              </div>
              <div class="col-md-12">Assunto: {{ result_detalhes.assunto }}</div>
              <div class="col-md-12" style="margin-bottom: 20px;margin-top:20px;">
                {{ result_detalhes.conteudo }}
              </div>
              <div
                class="col-md-12"
                style="font-weight: 700"
                v-if="result_detalhes.bairro"
              >
                Local ocorrência
              </div>
              
              <div class="col-md-12" v-if="result_detalhes.rua ">
                {{ result_detalhes.rua }}, {{ result_detalhes.numero }} -
                {{ result_detalhes.complemento }} - Bairro: {{ result_detalhes.bairro }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <div class="col-md-12" id="table-manifestacao">
      <vue-good-table
        :columns="columns"
        :rows="manifestacao_exibir"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [5, 10, 15, 30],
          dropdownAllowAll: false,
          nextLabel: 'Próximo',
          prevLabel: 'Anterior',
          rowsPerPageLabel: 'Linhas por página',
          ofLabel: 'de',
          pageLabel: 'pagina',
          allLabel: 'All',
        }"
      >
        <div slot="table-actions" style="position: relative;margin-top: 50px;margin-bottom: 8px;">
          <button
            class="btn btn-danger btn-fill btn-sm"
            style="margin-right: 8px"
            @click="listarTudo('Espera')"
          >
            Espera
          </button>
          <button
            class="btn btn-primary btn-fill btn-sm"
            style="margin-right: 8px"
            @click="listarTudo('Aberta')"
          >
            Aberta
          </button>
          <button
            class="btn btn-default btn-fill btn-sm"
            @click="listarTudo('Finalizada')"
            style="margin-right: 8px"
          >
            Finalizada
          </button>
          <button class="btn btn-default btn-fill btn-sm" @click="listarTudo()">
            Exibir Tudo
          </button>
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'assunto'">
            <!-- {{props.row.assunto}}-->
            <div v-if="props.row.assunto.length > 22">
              {{ props.row.assunto.substr(0, 22) }} ...
            </div>
            <div v-else>
              {{ props.row.assunto.substr(0, 22) }}
            </div>
          </div>
          
          
          <div v-if="props.column.field == 'liberar' ">
            
            <div v-if="props.row.liberar == 1 ">
               <span class="badge badge-success">Liberada Pelo Ouvidor</span>
            </div> 
            <div v-if="props.row.liberar == 0 ">
               <span class="badge badge-danger">Aguardando Liberação do Ouvidor</span>
            </div> 
          </div>


          <div v-if="props.column.field == 'abertura' ">
            
            <div v-if="props.row.abertura == 'Aberta' ">
               <span class="badge badge-primary">{{props.row.abertura}}</span>
            </div> 
            <div v-if="props.row.abertura == 'Espera' ">
               <span class="badge badge-danger">{{props.row.abertura}}</span>
            </div>
            <div v-if="props.row.abertura == 'Finalizada' ">
               <span class="badge badge-secondary">{{props.row.abertura}}</span> 
            </div>  
          </div>  

          <span v-if="props.column.field == 'action'">

             
            <button
              class="btn btn-default btn-sm btn-fill"
              @click="liberarManifesto(props.row.uuid, props.row)"
              v-if="props.row.abertura != 'Finalizada'"
              v-show="user.departamento == 0 || user.departamento == 1 || user.departamento == -1"
              data-toggle="tooltip"
              title="Liberar Manifestação"
              style="
                margin-right: 5px;
                border-color: rgb(167 167 167);
                color: rgb(255 255 255);
                background-color: rgb(104 208 203);
              "
            >
              <i class="fa fa-list-alt" aria-hidden="true"></i>
            </button>

            <button
              class="btn btn-default  btn-sm btn-fill"
              @click="finalizarManifestacao(props.row.uuid)"
              v-if="props.row.abertura != 'Finalizada'"
              v-show="user.departamento == 0 || user.departamento == 1 || user.departamento == -1"
              data-toggle="tooltip"
              title="Finalizar Manifestação"
              style="
                margin-right: 5px;
                border-color: rgb(167 167 167);
                color: rgb(255 255 255);
                background-color: rgb(208 104 104);
              "
            >
              <i class="fa fa-check-square" aria-hidden="true"></i>
            </button>



            <button
              class="btn btn-default btn-sm btn-fill"
              @click="detalhes(props.row.uuid, props.row)"
              v-if="props.row.abertura != 'Finalizada'"
              data-toggle="tooltip"
              title="Visualizar Manifestação"
              style="
                margin-right: 5px;
                border-color: #a7a7a7;
                color: #a7a7a7;
                background-color: #e4e4e4;
              "
            >
              <i class="fa fa-eye"></i>
            </button>
            
            <button
              class="btn btn-success btn-sm btn-fill"
              @click="ativarManifestacao(props.row.uuid, props.row)"
              data-toggle="tooltip"
              title="Abrir Manifestação"
              style="
                margin-right: 5px;
                border-color: #0c9440;
                color: #fff;
                background-color: #0c9440;
              "
              v-if="props.row.abertura == 'Espera'"
            >
              <i class="fa fa-play" aria-hidden="true"></i>
            </button>

            <button
              class="btn btn-success btn-sm btn-fill"
              @click="visualizarComentario(props.row)"
              v-if="props.row.abertura == 'Aberta'"
              data-toggle="tooltip"
              title="Visualizar Manifestações em Aberto"
              style="
                margin-right: 5px;
                border-color: #0c9440;
                color: #fff;
                background-color: #0c9440;
              "
            >
              <i class="fa fa-pencil-square-o"></i>
            </button>
            <button
              class="btn btn-primary btn-sm btn-fill"
              @click="ativarManifestacao(props.row.uuid, props.row)"
              data-toggle="tooltip"
              title="Reabrir Manifestação"
              style="
                margin-right: 5px;
                border-color: #0c9440;
                color: #fff;
                background-color: #0c9440;
              "
              v-if="props.row.abertura == 'Finalizada'"
            >
              <i class="fa fa-play" aria-hidden="true"></i>
            </button>

            <button
              class="btn btn-primary btn-sm btn-fill"
              @click="transferir_option(props.row)"
              style="margin-left: 5px"
              v-if="props.row.abertura != 'Finalizada'"
              data-toggle="tooltip"
              title="Transferir para Outra Unidade Organizacional"
            >
              <i class="fa fa-share" aria-hidden="true"></i>
            </button>
          </span>
          <span v-else>
            <span v-if="props.column.field != 'assunto' && props.column.field != 'abertura' && props.column.field != 'liberar'">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/manifestacaoController.js";
import "src/controller/sistema/assuntoSecretariaController.js";
import "src/controller/sistema/usuarioController.js";
import "src/controller/sistema/permissaoController.js";
import Reload from "src/components/Reload-v1.vue";

export default {
  name: "manifestacao-table",
  components: {
    VueGoodTable,
    Reload,
  },
  props: {
    /*id: {
      require: true
    } */
  },
  data() {
    return {
      columns: [],
      manifestacao: [],
      manifestacao_exibir: [],
      result_detalhes: null,
      user: {
        admin: null,
        admin_sistema: null,
        id: null,
        departamneto: null,
        grupo: 0,
      },
      reload_hab: false,
      status:null,
    };
  },
  methods: {
    transferir_option(row) {
      try {
        this.$router.push({
          name: "transferirManifestacao",
          params: { row: row },
        });
      } catch (error) {}
    },
    visualizarComentario(row) {
      let result_detalhes = row;
      this.$router.push({
        name: "Conversa",
        params: { result_detalhes: result_detalhes },
      });
    },
    async liberarManifesto(id, row){
      try {
        let data = await axios.post('manifestacaos/liberar/'+id);
        this.listarTudo();
      } catch (e) {
        console.log(e);
      }
    },
    async ativarManifestacao(id, row) {
      try {
        var r = confirm("Deseja Ativar essa Manifestação?");
        if (r == true) {
          let abertura = "Aberta";
          let me = await this.$me();
          let resposta = me;
          this.reload_hab = true;
          let data = await this.$ativarManifesto(id, abertura, resposta.id);
          if (data) {
            this.reload_hab = false;
          }
          row.abertura = abertura;
          let result_detalhes = row;
          this.$router.push({
            name: "Conversa",
            params: { result_detalhes: result_detalhes },
          });
        } else {
        }
      } catch (error) {
        this.reload_hab = false;
      }
    },
    async detalhes(id, row) {
      try {
        let abertura = "Aberta";
        let me = await this.$me();
        let resposta = me;
        if (row.abertura != "Aberta") {
          this.reload_hab = true;
          let data = await this.$ativarManifesto(id, abertura, resposta.id);
          if (data) {
            this.reload_hab = false;
          }
          row.abertura = abertura;
          this.result_detalhes = row;
          this.$modal.show('manif');
          this.manifestacao_exibir = [];
          this.listarTudo();
        }else{
          row.abertura = abertura;
          this.result_detalhes = row;
          this.$modal.show('manif');
        }
      } catch (error) {}
    },
    async listarTudo(status) {
      try {
        this.status = status;
        let data = [];
        this.manifestacao = [];
        this.manifestacao_exibir = [];

        this.user.departamento = this.user.departamento.toString();
        if(this.user.departamento[0] == '-'){
          let dep = this.user.departamento.split('-');
          if(dep[0] == ''){
            dep.shift();
          }
          this.user.departamento = dep;
        }else{
          let dep = this.user.departamento.split(',');
          if(dep[0] == ''){
            dep.shift();
          }
          this.user.departamento = dep;
        }

        let count = this.user.departamento.length;

        if(count == 1){
          if (this.user.departamento == 0 || this.user.departamento == 1 || this.user.departamento == -1) {
            data = await this.$listarManifestos();
          } else {
            data = await this.$listarManifestosPorDepartamento(
              this.user.departamento
            );
          }

          this.manifestacao = data.data.reverse();

        }else{
           data = [];
           for (let departamento of this.user.departamento) {
              let d = await this.$listarManifestosPorDepartamento(departamento);
              for (let index = 0; index < d.data.length; index++) {
                let element = d.data[index];
                data.push(element);
              }
              
           }
          this.manifestacao = data;
        }
        
        
        let s = await this.$secretaria();
        let secretarias = s.data;

       
      
        this.manifestacao.forEach((array) => {
          this.filtro(array, secretarias, this.status);
        });
       
      } catch (e) {
        console.log(e);
      }
    },
    async filtro(array, secretarias, status) {
      try {
        let secretaria;
        let id_secretaria;
        
        secretarias.forEach((element) => {
          if (array.secretaria == element.id) {
            secretaria = element.secretaria;
            id_secretaria = element.id;
          }
        });

        let datatotal = array.created_at;
        let datacompleta = datatotal.split(" ");
        let somentedata = datacompleta[0];
        somentedata = somentedata.split("-");
        let dataformat = somentedata[2]+'/'+somentedata[1]+'/'+somentedata[0];

        let manifesto = {
          uuid: array.uuid,
          numero_manifesto: array.uuid,
          tipo_assunto: array.tipo_assunto,
          assunto: array.assunto,
          secretaria: secretaria,
          abertura: array.abertura,
          liberar : array.liberar,
          conteudo: array.conteudo,
          cidadao_login: array.cidadao_login,
          anonimo: array.anonimo,
          numero: array.numero,
          complemento: array.complemento,
          rua: array.rua,
          bairro: array.bairro,
          latitude: array.latitude,
          longitude: array.longitude,
          created_at: dataformat,
          sigilo: array.sigilo,
        };

        if (!status) {
          if (array.abertura != "Finalizada") {
            if (this.user.admin == true) {
             
              this.manifestacao_exibir.push(manifesto);
            }

            if (this.user.admin_sistema == true) {
              let count = this.user.departamento.length;
              
              if(count == 1){
                if (this.user.departamento == id_secretaria || this.user.departamento == 1) {
                  this.manifestacao_exibir.push(manifesto);
                }
              }else{
                this.manifestacao_exibir.push(manifesto);
              }
            }
          }
        } else {
          if (status == "Aberta") {
            if (array.abertura == "Aberta") {
              this.manifestacao_exibir.push(manifesto);
            }
          } else if (status == "Espera") {
            if (array.abertura == "Espera") {
              this.manifestacao_exibir.push(manifesto);
            }
          } else if (status == "Finalizada") {
            if (array.abertura == "Finalizada") {
              this.manifestacao_exibir.push(manifesto);
            }
          }

        }
      } catch (error) {}
    },
    async checkarPermissao() {
      try {
        let me = await this.$me();
        let permissao = 0;

        this.listarTudo();

        if (me.grupo != 0) {
          let dataSua = await this.$suaPermissao(me.grupo);
          let stringDep = dataSua.data;
          let stringCompleto = stringDep[0].hab_departamentos;
          let arrayDept = stringCompleto.split(",");
          //console.log(arrayDept[1]);

          arrayDept.forEach((elem) => {
            if (elem == store.departamento) {
              permissao = 1;
            }
          });
        }
      } catch (error) {}
    },
    mostarManifestacao(){
      this.$modal.show('manif');
    },
    async finalizarManifestacao(uuid){
        try {
          var r = confirm("Deseja Finalizar essa Manifestação?");
          if (r == true) {
              let abertura = "Finalizada";
              let me = await this.$me();
              let resposta = me;
              let data = await this.$ativarManifesto(uuid,abertura,resposta.id);
              
              if(data.msg =="status trocado!"){
                this.$alert("Manifestação foi finalizada!");
              }
              this.listarTudo();
          } else {
            
          }
        } catch (e) {
          console.log(e)
        }
    },
  },
  mounted: function () {
    var thElm;
    var startOffset;

    Array.prototype.forEach.call(
    document.querySelectorAll("table thead th"),
    function (th) {
        th.style.position = 'relative';

        var grip = document.createElement('div');
        grip.innerHTML = "&nbsp;";
        grip.style.top = 0;
        grip.style.right = 0;
        grip.style.bottom = 0;
        grip.style.width = '5px';
        grip.style.position = 'absolute';
        grip.style.cursor = 'col-resize';
        grip.addEventListener('mousedown', function (e) {
            thElm = th;
            startOffset = th.offsetWidth - e.pageX;
        });

        th.appendChild(grip);
    });

    document.addEventListener('mousemove', function (e) {
        if (thElm) {
            thElm.style.width = startOffset + e.pageX + 'px';
        }
    });

    document.addEventListener('mouseup', function () {
        thElm = undefined;
    });
  },
  beforeMount() {
    try {
      this.user.departamento = store.departamento;
      this.user.admin = store.admin;
      this.user.admin_sistema = store.admin_sistema;
      this.user.id = store.id;
      this.user.grupo = store.grupo;

      if(this.user.departamento == 0 || this.user.departamento == 1 || this.user.departamento == -1){
        this.columns =[
            {
              label: "Numero da Manifestação",
              field: "numero_manifesto",
            },
            {
              label: "Tipo",
              field: "tipo_assunto",
            },
            {
              label: "Assunto",
              field: "assunto",
            },
            {
              label: "Unidade Organizacional",
              field: "secretaria",
            },
            {
              label: "Data",
              field: "created_at",
            },
            {
              label: "Status de Movimentação",
              field: "liberar",
            },
            {
              label: "Status",
              field: "abertura",
            },
            {
              label: "Ações",
              field: "action",
              sortable: false,
            },
            {
              label: "id",
              field: "uuid",
              hidden: true,
            },
        ];

      }else{
        this.columns =[
          {
            label: "Numero da Manifestação",
            field: "numero_manifesto",
          },
          {
            label: "Tipo",
            field: "tipo_assunto",
          },
          {
            label: "Assunto",
            field: "assunto",
          },
          {
            label: "Unidade Organizacional",
            field: "secretaria",
          },
          {
            label: "Data",
            field: "created_at",
          },
          {
            label: "Status",
            field: "abertura",
          },
          {
            label: "Ações",
            field: "action",
            sortable: false,
          },
          {
            label: "id",
            field: "uuid",
            hidden: true,
          },
        ];
      }

      this.checkarPermissao();
    } catch (e) {}
  },
};

</script>

<style>


#table-manifestacao .vgt-wrap .vgt-inner-wrap .vgt-global-search .vgt-global-search__input{
  position: absolute;
  width: 90%;
}
</style>
<style>
  .vm--modal{
     overflow-y: scroll !important;
  }
</style>